import { createStore, requestReduceEndMiddleware, INIT } from '@jd/jmtd-state';
export { INIT } from '@jd/jmtd-state';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React, { PureComponent } from 'react';

function flat(list) {
  return list.reduce(function (acc, cur) {
    if (Array.isArray(cur)) {
      acc.push.apply(acc, _toConsumableArray(flat(cur)));
    } else {
      acc.push(cur);
    }

    return acc;
  }, []);
}

function type(target) {
  return [].concat(/\[object ([a-zA-Z]+)\]/.exec(Object.prototype.toString.call(target)) || [])[1];
}

function Is(typeName) {
  return function (target) {
    return type(target) === typeName;
  };
}
/**
 *
 * 判断一个变量是否是对象类型
 * @export
 * @param {*} target
 * @returns {bool} 是否匹配
 * @example
 *
 * isObject(123) false
 * isObject({}) true
 */

var isObject = Is('Object');

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(iterate);

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function hasOwnProperty(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}
function iterate(object) {
  var symbol,
      key,
      _iterator,
      _step,
      _key,
      _args = arguments;

  return _regeneratorRuntime.wrap(function iterate$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          symbol = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
          _context.t0 = _regeneratorRuntime.keys(object);

        case 2:
          if ((_context.t1 = _context.t0()).done) {
            _context.next = 9;
            break;
          }

          key = _context.t1.value;

          if (!hasOwnProperty(object, key)) {
            _context.next = 7;
            break;
          }

          _context.next = 7;
          return [object[key], key];

        case 7:
          _context.next = 2;
          break;

        case 9:
          if (!symbol) {
            _context.next = 27;
            break;
          }

          _iterator = _createForOfIteratorHelper$1(Object.getOwnPropertySymbols(object));
          _context.prev = 11;

          _iterator.s();

        case 13:
          if ((_step = _iterator.n()).done) {
            _context.next = 19;
            break;
          }

          _key = _step.value;
          _context.next = 17;
          return [object[_key], _key];

        case 17:
          _context.next = 13;
          break;

        case 19:
          _context.next = 24;
          break;

        case 21:
          _context.prev = 21;
          _context.t2 = _context["catch"](11);

          _iterator.e(_context.t2);

        case 24:
          _context.prev = 24;

          _iterator.f();

          return _context.finish(24);

        case 27:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[11, 21, 24, 27]]);
}
function forOwn(object, callback) {
  var symbol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var _iterator2 = _createForOfIteratorHelper$1(iterate(object, symbol)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
          value = _step2$value[0],
          key = _step2$value[1];

      callback(value, key);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}

function empty(object) {
  forOwn(object, function (_, key) {
    delete object[key];
  }, true);
  return object;
}

var _excluded = ["name", "reducer"],
    _excluded2 = ["name"],
    _excluded3 = ["name"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var FETCH_CACHE = Symbol('fetch_cache');
var RESET = Symbol('reset');

function defaultReducer(_ref) {
  var actionType = _ref.actionType,
      setState = _ref.setState;

  if (actionType === INIT) {
    setState(undefined);
  }
}

function Group(_ref2) {
  var groups = _ref2.groups,
      _ref2$onChange = _ref2.onChange,
      onChange = _ref2$onChange === void 0 ? function () {} : _ref2$onChange,
      GroupComponent = _ref2.render;
  var commonGroupMap = {}; // 公共group

  var fieldsMap = {}; // symbol映射field

  var groupSymbolMap = {};
  var groupFieldsMap = {};
  var groupsCache = {}; // group的缓存表

  var currentChangedState = {}; // 处于change状态的字段表

  var currentChangedGroup = {}; // 处于change状态的group表

  var requestCount = 0;
  var loadingCallbackGroup = {}; // 组加载promise完成回调

  var loadingPromiseGroup = {}; // 组加载完成promise
  // TAG 统计common group并生成group上下文

  forOwn(groups, function (_ref3, groupName) {
    var common = _ref3.common;
    groupsCache[groupName] = {};

    if (common) {
      commonGroupMap[groupName] = true;
    }
  }); // TAG 生成字段表

  forOwn(groups, function (_ref4, groupName) {
    var fields = _ref4.fields,
        showConfirm = _ref4.showConfirm;
    var symbolMap = groupSymbolMap[groupName] = {};
    var fieldList = groupFieldsMap[groupName] = [];
    fields.forEach(function (_ref5) {
      var name = _ref5.name,
          _ref5$reducer = _ref5.reducer,
          reducer = _ref5$reducer === void 0 ? defaultReducer : _ref5$reducer,
          config = _objectWithoutProperties(_ref5, _excluded);

      var fieldSymbol = Symbol("".concat(groupName, "-").concat(name));
      var cacheSymbol = Symbol("".concat(groupName, "-").concat(name, "-cache"));
      var contextSymbol = Symbol("".concat(groupName, "-").concat(name, "-context"));
      var loadingSymbol = Symbol("".concat(groupName, "-").concat(name, "-loading"));
      symbolMap[name] = fieldSymbol;
      var field = fieldsMap[fieldSymbol] = fieldsMap[cacheSymbol] = {
        reduceEndSymbol: Symbol("".concat(groupName, "-").concat(name, "-reduce-end")),
        config: config,
        fieldCache: {},
        initialized: false,
        ready: false,
        common: commonGroupMap[groupName],
        contextSymbol: contextSymbol,
        renderSymbol: showConfirm ? cacheSymbol : fieldSymbol,
        // 渲染使用的symbol，在有确认按钮时，使用cache symbol
        groupName: groupName,
        symbol: fieldSymbol,
        cacheSymbol: cacheSymbol,
        loadingSymbol: loadingSymbol,
        name: name,
        reducer: reducer
      };
      fieldList.push(field);
    });
  }); // TAG 获取一个Group的symbol

  function getGroupSymbols(groupNames) {
    return groupNames.reduce(function (list, name) {
      return list.concat(Object.values(groupSymbolMap[name]));
    }, []);
  } // TAG 获取groupName对应的字段，包含common Group


  function getGroupNames(groupName) {
    return Object.keys(_objectSpread(_objectSpread({}, commonGroupMap), {}, _defineProperty({}, groupName, true)));
  } // TAG 取出公共部分和目标group，将它们的值转换成一个数组


  function _getFields(targetGroupName, state) {
    return flat(getGroupNames(targetGroupName).map(function (groupName) {
      return groups[groupName].fields.map(function (_ref6) {
        var name = _ref6.name,
            config = _objectWithoutProperties(_ref6, _excluded2);

        var symbol = groupSymbolMap[groupName][name];
        return {
          symbol: symbol,
          name: name,
          config: config,
          state: state[symbol]
        };
      });
    }));
  } // TAG 判断一个group是否处于加载状态
  // 如果一个group中的某个字段处于loading（包括公共部分），则整体处于loading


  function isGroupLoading(groupName, state) {
    return _getFields(groupName, state).some(function (_ref7) {
      var symbol = _ref7.symbol;
      return !!state[fieldsMap[symbol].loadingSymbol];
    });
  } // TAG 判断一个group是否处于ready状态
  // 如果一个group中的每个字段处于ready（包括公共部分），则整体处于ready


  function _isGroupReady(groupName, state) {
    return _getFields(groupName, state).every(function (_ref8) {
      var symbol = _ref8.symbol;
      return fieldsMap[symbol].ready;
    });
  }

  var store = createStore(requestReduceEndMiddleware( /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(reducerContext) {
      var _getState, _setState3, actionType, actionData, changedState, _requestReduceEnd, dispatch, commonGroupChanged, localChangedGroup, someStateChanged, action, showConfirm;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _getState = reducerContext.getState, _setState3 = reducerContext.setState, actionType = reducerContext.actionType, actionData = reducerContext.actionData, changedState = reducerContext.changedState, _requestReduceEnd = reducerContext.requestReduceEnd, dispatch = reducerContext.dispatch;
              commonGroupChanged = {}; // 全局变化

              localChangedGroup = {}; // 局部变化

              someStateChanged = Object.keys(changedState).length + Object.getOwnPropertySymbols(changedState).length > 0;
              action = {
                actionType: actionType,
                actionData: actionData
              };
              forOwn(changedState, function (_, fieldSymbol) {
                var field = fieldsMap[fieldSymbol];

                if (!field) {
                  return;
                }

                var symbol = field.symbol,
                    renderSymbol = field.renderSymbol,
                    common = field.common,
                    name = field.name,
                    groupName = field.groupName; // 公共变化

                if (symbol === fieldSymbol && common) {
                  var commonChanged = commonGroupChanged[groupName] = commonGroupChanged[groupName] || {};
                  commonChanged[name] = true;
                } else if (fieldSymbol === renderSymbol) {
                  var localChanged = localChangedGroup[groupName] = localChangedGroup[groupName] || {};
                  localChanged[name] = true;
                }

                currentChangedState = _objectSpread(_objectSpread({}, currentChangedState), {}, _defineProperty({}, fieldSymbol, true));
              }, true); // TAG 处理重置

              if (actionType === RESET) {
                empty(groupsCache[actionData]);
                showConfirm = groups[actionData].showConfirm;
                action = {
                  actionType: INIT
                };
                groupFieldsMap[actionData].forEach(function (field) {
                  var fieldCache = field.fieldCache,
                      contextSymbol = field.contextSymbol;
                  empty(fieldCache);

                  if (!showConfirm) {
                    field.ready = false;
                  }

                  field.initialized = false;

                  _setState3(_defineProperty({}, contextSymbol, null));
                });
              }

              _context4.next = 9;
              return Promise.all(Object.keys(groups).map( /*#__PURE__*/function () {
                var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(groupName) {
                  var _groups$groupName, showConfirm, reducer, groupChangedState, hasChanged, localChanged;

                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _groups$groupName = groups[groupName], showConfirm = _groups$groupName.showConfirm, reducer = _groups$groupName.reducer; // 调用group的reducer

                          // 调用group的reducer
                          if (reducer) {
                            reducer(reducerContext);
                          }

                          groupChangedState = {}; // 更改的状态

                          // 更改的状态
                          hasChanged = false; // 是否有更改

                          if (!(actionType === RESET)) {
                            _context3.next = 9;
                            break;
                          }

                          if (!(actionData !== groupName)) {
                            _context3.next = 7;
                            break;
                          }

                          return _context3.abrupt("return");

                        case 7:
                          _context3.next = 15;
                          break;

                        case 9:
                          if (!someStateChanged) {
                            _context3.next = 15;
                            break;
                          }

                          // 计算本次reduce是否影响到当前组
                          forOwn(commonGroupChanged, function (changed, targetGroupName) {
                            // 当确认时，忽略当前组的全局变化
                            if (showConfirm && targetGroupName === groupName) {
                              return;
                            }

                            groupChangedState = _objectSpread(_objectSpread({}, groupChangedState), changed);
                            hasChanged = true;
                          }); // 计算局部变化

                          // 计算局部变化
                          localChanged = localChangedGroup[groupName];

                          if (localChanged) {
                            groupChangedState = _objectSpread(_objectSpread({}, groupChangedState), localChanged);
                            hasChanged = true;
                          }

                          if (hasChanged) {
                            _context3.next = 15;
                            break;
                          }

                          return _context3.abrupt("return");

                        case 15:
                          // 添加loading promise
                          if (!loadingCallbackGroup[groupName]) {
                            loadingPromiseGroup[groupName] = new Promise(function (resolve) {
                              loadingCallbackGroup[groupName] = resolve;
                            });
                          }

                          _context3.next = 18;
                          return Promise.all(groupFieldsMap[groupName].map( /*#__PURE__*/function () {
                            var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(field) {
                              var symbol, fieldCache, contextSymbol, renderSymbol, loadingSymbol, reducer, reduceEndSymbol, reducerContext;
                              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                                while (1) {
                                  switch (_context2.prev = _context2.next) {
                                    case 0:
                                      symbol = field.symbol, fieldCache = field.fieldCache, contextSymbol = field.contextSymbol, renderSymbol = field.renderSymbol, loadingSymbol = field.loadingSymbol, reducer = field.reducer, reduceEndSymbol = field.reduceEndSymbol;
                                      reducerContext = _objectSpread(_objectSpread({}, action), {}, {
                                        dispatch: dispatch,
                                        groupCache: groupsCache[groupName],
                                        fieldCache: fieldCache,
                                        changedState: groupChangedState,
                                        isGroupReady: function isGroupReady(n) {
                                          return _isGroupReady(n, _getState());
                                        },
                                        setContext: function setContext(nextContext) {
                                          _setState3(_defineProperty({}, contextSymbol, nextContext));
                                        },
                                        getContext: function getContext() {
                                          return _getState()[contextSymbol];
                                        },
                                        getState: function getState() {
                                          var allState = _getState();

                                          return getGroupSymbols(getGroupNames(groupName)).reduce(function (total, targetSymbol) {
                                            var _fieldsMap$targetSymb = fieldsMap[targetSymbol],
                                                initialized = _fieldsMap$targetSymb.initialized,
                                                targetRenderSymbol = _fieldsMap$targetSymb.renderSymbol,
                                                targetGroupName = _fieldsMap$targetSymb.groupName,
                                                name = _fieldsMap$targetSymb.name;
                                            return _objectSpread(_objectSpread({}, total), {}, _defineProperty({}, name, initialized ? allState[targetGroupName === groupName ? targetRenderSymbol : targetSymbol] : null));
                                          }, {});
                                        },
                                        setState: function setState(nextState, setActionType) {
                                          var toSet = _defineProperty({}, renderSymbol, nextState); // 如果未ready，更新主状态


                                          // 如果未ready，更新主状态
                                          if (!field.ready) {
                                            toSet[symbol] = nextState;
                                          }

                                          field.initialized = true;

                                          _setState3(toSet, setActionType);
                                        },
                                        // 取数，同时更新字段loading状态（可选）
                                        // 第二个参数是对象：{ loading, cacheKey }
                                        // 否侧是cacheKey
                                        fetch: function fetch(fetcher, arg) {
                                          var _getState2;

                                          var cacheKey = FETCH_CACHE; // 缓存key

                                          // 缓存key
                                          var loading = true; // fetch时是否更新loading状态

                                          // fetch时是否更新loading状态
                                          if (isObject(arg)) {
                                            loading = arg.loading;
                                            cacheKey = arg.cacheKey;
                                          } else if (arg) {
                                            cacheKey = arg;
                                          }

                                          if (loading && !((_getState2 = _getState()) !== null && _getState2 !== void 0 && _getState2[loadingSymbol])) {
                                            _setState3(_defineProperty({}, loadingSymbol, true));
                                          }

                                          var promise = fieldCache[cacheKey] = fetcher().then(function (result) {
                                            if (fieldCache[cacheKey] === promise) {
                                              loading && _setState3(_defineProperty({}, loadingSymbol, false));
                                              return [true, result];
                                            }

                                            return [false];
                                          }).catch(function (e) {
                                            if (fieldCache[cacheKey] === promise) {
                                              loading && _setState3(_defineProperty({}, loadingSymbol, false));
                                              throw e;
                                            }

                                            return [false];
                                          });
                                          return promise;
                                        }
                                      });
                                      _context2.next = 4;
                                      return reducer(_objectSpread(_objectSpread({}, reducerContext), {}, {
                                        requestReduceEnd: function requestReduceEnd(task) {
                                          var stateName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : reduceEndSymbol;

                                          if (_requestReduceEnd( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                                            return _regeneratorRuntime.wrap(function _callee$(_context) {
                                              while (1) {
                                                switch (_context.prev = _context.next) {
                                                  case 0:
                                                    _context.next = 2;
                                                    return task();

                                                  case 2:
                                                    --requestCount;

                                                  case 3:
                                                  case "end":
                                                    return _context.stop();
                                                }
                                              }
                                            }, _callee);
                                          })), stateName)) {
                                            ++requestCount;
                                          }
                                        },
                                        defaultReducer: defaultReducer.bind(null, reducerContext)
                                      }));

                                    case 4:
                                    case "end":
                                      return _context2.stop();
                                  }
                                }
                              }, _callee2);
                            }));

                            return function (_x3) {
                              return _ref11.apply(this, arguments);
                            };
                          }()));

                        case 18:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x2) {
                  return _ref10.apply(this, arguments);
                };
              }()));

            case 9:
              // TAG 计算onChange
              if (Object.getOwnPropertySymbols(currentChangedState).length) {
                _requestReduceEnd(function task() {
                  // 如果有任务，等待任务完成
                  if (requestCount !== 0) {
                    _requestReduceEnd(task);

                    return;
                  }

                  var changedGroup = {};

                  var state = _getState();

                  forOwn(currentChangedState, function (_, fieldSymbol) {
                    // 检测是否ready
                    var field = fieldsMap[fieldSymbol];

                    if (field && field.symbol === fieldSymbol) {
                      var ready = field.ready,
                          groupName = field.groupName,
                          loadingSymbol = field.loadingSymbol,
                          config = field.config; // 更新ready状态，当一个Group中所有字段都ready时，改group设置为ready

                      if (!ready && !state[loadingSymbol]) {
                        field.ready = true;
                      }

                      if (!isGroupLoading(groupName, state) && !config.justForRender) {
                        changedGroup[groupName] = true;
                      }

                      if (groups[groupName].common) {
                        // 公共组改变相当于每个组都发生了变化
                        forOwn(groups, function (_1, targetGroupName) {
                          currentChangedGroup[targetGroupName] = true;
                        });
                      } else {
                        currentChangedGroup[groupName] = true;
                      }
                    }
                  }, true); // 处理cascadeConfirm

                  var needCascadeConfirm;

                  for (var _i = 0, _Object$keys = Object.keys(changedGroup); _i < _Object$keys.length; _i++) {
                    var groupName = _Object$keys[_i];
                    var cascadeConfirm = groups[groupName].cascadeConfirm; // 如果当前changedGroup有cascadeConfirm，并且它要级联的group不在changedGroup，记录为needCascadeConfirm

                    if (cascadeConfirm) {
                      var _iterator = _createForOfIteratorHelper(cascadeConfirm),
                          _step;

                      try {
                        for (_iterator.s(); !(_step = _iterator.n()).done;) {
                          var g = _step.value;

                          if (!changedGroup[g]) {
                            needCascadeConfirm = _objectSpread(_objectSpread({}, needCascadeConfirm), {}, _defineProperty({}, g, true));
                          }
                        }
                      } catch (err) {
                        _iterator.e(err);
                      } finally {
                        _iterator.f();
                      }
                    }
                  } // 如果needCascadeConfirm，触发目标group的confirm，跳过后续的回调


                  if (needCascadeConfirm) {
                    for (var _i2 = 0, _Object$keys2 = Object.keys(needCascadeConfirm); _i2 < _Object$keys2.length; _i2++) {
                      var _groupName = _Object$keys2[_i2];

                      // eslint-disable-next-line no-use-before-define
                      _confirm(_groupName, true);
                    }

                    return;
                  } // 触发onChange


                  if (Object.keys(changedGroup).length) {
                    onChange({
                      changedGroup: currentChangedGroup,
                      changedState: currentChangedState,
                      getFields: function getFields(targetGroupName) {
                        // 取出公共部分和目标group，将它们的值转换成一个数组
                        return _getFields(targetGroupName, state);
                      }
                    }); // 触发后清空change状态表

                    currentChangedState = {};
                    currentChangedGroup = {};
                  }
                });
              }

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x) {
      return _ref9.apply(this, arguments);
    };
  }())); // 触发loading promise

  store.subscribe(function (states) {
    try {
      Object.keys(loadingCallbackGroup).forEach(function (groupName) {
        // 如果不出雨loading状态，触发回调，删除回调
        if (!isGroupLoading(groupName, states)) {
          loadingCallbackGroup[groupName] && loadingCallbackGroup[groupName]();
          delete loadingCallbackGroup[groupName];
        }
      }); // eslint-disable-next-line no-empty
    } catch (_unused) {}
  }); // TAG 是否有字段发生了更改

  function hasFieldChanged(allState, groupName) {
    for (var _i3 = 0, _Object$values = Object.values(groupSymbolMap[groupName]); _i3 < _Object$values.length; _i3++) {
      var symbol = _Object$values[_i3];
      var cacheSymbol = fieldsMap[symbol].cacheSymbol;

      if (allState[symbol] !== allState[cacheSymbol]) {
        return true;
      }
    }

    return false;
  } // TAG 确认


  function _confirm(groupName) {
    var alwaysTriggerChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!groups[groupName].showConfirm) {
      return;
    }

    var toSet = {};
    var allState = store.getState();
    Object.values(groupSymbolMap[groupName]).forEach(function (symbol) {
      var cacheSymbol = fieldsMap[symbol].cacheSymbol;

      if (alwaysTriggerChange || allState[symbol] !== allState[cacheSymbol]) {
        toSet[symbol] = allState[cacheSymbol];
      }
    });
    store.setState(toSet);
  } // TAG 重置


  function _reset(groupName) {
    store.dispatch(RESET, groupName);
  }

  var Groups = {};
  forOwn(groups, function (groupValue, groupName) {
    function getState() {
      var allState = store.getState();
      return getGroupSymbols([groupName]).reduce(function (total, symbol) {
        var _objectSpread6;

        var _fieldsMap$symbol = fieldsMap[symbol],
            loadingSymbol = _fieldsMap$symbol.loadingSymbol,
            name = _fieldsMap$symbol.name,
            renderSymbol = _fieldsMap$symbol.renderSymbol,
            contextSymbol = _fieldsMap$symbol.contextSymbol;
        return _objectSpread(_objectSpread({}, total), {}, (_objectSpread6 = {}, _defineProperty(_objectSpread6, JSON.stringify({
          name: name
        }), allState[renderSymbol]), _defineProperty(_objectSpread6, JSON.stringify({
          name: name,
          loading: true
        }), allState[loadingSymbol]), _defineProperty(_objectSpread6, JSON.stringify({
          name: name,
          context: true
        }), allState[contextSymbol]), _objectSpread6));
      }, {});
    }

    function isLoading() {
      return isGroupLoading(groupName, store.getState());
    }

    function isReady() {
      return _isGroupReady(groupName, store.getState());
    }

    var genComponent = function genComponent(Component) {
      return /*#__PURE__*/function (_PureComponent) {
        _inherits(GroupRender, _PureComponent);

        var _super = _createSuper(GroupRender);

        function GroupRender(props) {
          var _this;

          _classCallCheck(this, GroupRender);

          _this = _super.call(this, props);
          _this.state = _objectSpread({
            loading: isLoading(),
            ready: isReady()
          }, getState());
          return _this;
        }

        _createClass(GroupRender, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            var _this2 = this;

            this.unsubscribe = store.subscribe(function () {
              _this2.setState(_objectSpread(_objectSpread({}, getState()), {}, {
                loading: isLoading(),
                ready: isReady()
              }));
            });
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this.unsubscribe();
          }
        }, {
          key: "render",
          value: function render() {
            var _this$state = this.state,
                loading = _this$state.loading,
                ready = _this$state.ready,
                props = this.props;
            var allState = store.getState();

            var renderedProps = _objectSpread(_objectSpread({
              props: props,
              groupName: groupName
            }, groupValue), {}, {
              confirm: function confirm() {
                var alwaysTriggerChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                _confirm(groupName, alwaysTriggerChange);
              },
              reset: function reset() {
                _reset(groupName);
              },
              loading: loading,
              ready: ready,
              fields: groupValue.fields.map(function (_ref13) {
                var name = _ref13.name,
                    config = _objectWithoutProperties(_ref13, _excluded3);

                var symbol = groupSymbolMap[groupName][name];
                var _fieldsMap$symbol2 = fieldsMap[symbol],
                    loadingSymbol = _fieldsMap$symbol2.loadingSymbol,
                    fieldCache = _fieldsMap$symbol2.fieldCache,
                    renderSymbol = _fieldsMap$symbol2.renderSymbol,
                    contextSymbol = _fieldsMap$symbol2.contextSymbol,
                    fieldReady = _fieldsMap$symbol2.ready;
                return {
                  setContext: function setContext(nextContext) {
                    store.setState(_defineProperty({}, contextSymbol, nextContext));
                  },
                  setState: function setState(nextState, actionType) {
                    store.setState(_defineProperty({}, renderSymbol, nextState), actionType);
                  },
                  ready: fieldReady,
                  loading: allState[loadingSymbol],
                  name: name,
                  config: config,
                  fieldCache: fieldCache,
                  state: allState[renderSymbol],
                  context: allState[contextSymbol]
                };
              })
            });

            return /*#__PURE__*/React.createElement(Component, renderedProps);
          }
        }]);

        return GroupRender;
      }(PureComponent);
    };

    var Component = Groups[groupName] = genComponent(GroupComponent);
    var groupComponents = groupValue.groupComponents;

    if (groupComponents) {
      forOwn(groupComponents, function (comp, key) {
        Component[key] = genComponent(comp);
      });
    }
  });
  return {
    store: store,
    Groups: Groups,
    getGroupReady: function getGroupReady(groupName) {
      return _isGroupReady(groupName, store.getState());
    },
    getGroupLoading: function getGroupLoading(groupName) {
      return isGroupLoading(groupName, store.getState());
    },
    waitLoading: function waitLoading(groupName) {
      return loadingPromiseGroup[groupName];
    },
    hasFieldChanged: hasFieldChanged,
    confirm: _confirm,
    reset: _reset,
    setField: function setField(groupName, fieldName, props) {
      var showConfirm = groups[groupName].showConfirm;
      var _fieldsMap$groupSymbo = fieldsMap[groupSymbolMap[groupName][fieldName]],
          symbol = _fieldsMap$groupSymbo.symbol,
          cacheSymbol = _fieldsMap$groupSymbo.cacheSymbol;

      var toSet = _defineProperty({}, symbol, props);

      if (showConfirm) {
        toSet[cacheSymbol] = props;
      }

      return store.setState(toSet);
    },
    getField: function getField(groupName, fieldName) {
      return store.getState()[groupSymbolMap[groupName][fieldName]];
    },
    getFields: function getFields(groupName) {
      return _getFields(groupName, store.getState());
    },
    dispatch: store.dispatch
  };
}
Group.RESET = RESET;

export { Group };
